import React, { Component } from "react";

class Help extends Component {
  render() {
    return (
      <div>
        <a href="" className="btn btn-sm btn-outline-warning mt-2" data-toggle="modal" data-target="#staticBackdrop">
          Les meg før bestilling
        </a>
        <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-info" id="staticBackdropLabel">
                  Hjelp
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body text-dark">
                <ul className="list-group">
                  <li className="list-group-item">
                    <strong>LEVERING</strong>
                  </li>
                  <li className="list-group-item">Porto er inkludert.</li>
                  <li className="list-group-item">Hver skulptur har en egen betalingslink. Antallet kan justeres. Bestiller du ulike skulpturer sendes de alltid sammen uten ekstra fraktkostnad.</li>
                  <li className="list-group-item">
                    Leveringstid cirka 1 uke for bestillinger <strong>under</strong> kr. 3000,-
                  </li>
                  <li className="list-group-item">
                    Cirka 1-2 uker leveringstid for bestillinger <strong>over</strong> kr. 3000,-
                  </li>
                  <li className="list-group-item">
                    <strong>OM FARGER</strong>
                  </li>
                  <li className="list-group-item">Skulpturene er smidd i jern. Farge henviser kun til overflatebehandling.</li>
                  <li className="list-group-item">
                    <strong>OPPBEVARING / PLASSERING </strong>
                  </li>
                  <li className="list-group-item">
                    Plasser innendørs i romtemperatur for å unngå rust. <br></br>
                    <strong className="text-danger">⚠</strong>Ta kontakt for kostnadsfri overflatebehandling dersom skulpturen skal plasseres utendørs!
                  </li>
                  <li className="list-group-item">
                    <strong>KONTAKT</strong>
                  </li>
                  <li className="list-group-item">
                    Ved spørsmål ta kontakt med smeden på telefon <strong>91371718</strong> eller e-post <strong>tor-vegard@smedenisund.no</strong>
                  </li>
                  {/* <li className="list-group-item">
                    Velg den <strong>grå knappen</strong> for normal kortbetalning.
                  </li>
                  <li className="list-group-item text-danger">
                    Du behøver <strong>ikke</strong> registrere deg på PayPal.
                  </li> */}
                </ul>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal">
                  Skjønner
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Help;
